import { FormControl, FormGroup } from "@angular/forms";
import { CalcTemplate } from "./calctemplate";
import { Utility } from "./utility";
import { Component_MAWP } from "./component_mawp";

// Dedicated MFH calc/validation state (separate from MAWP/MAEP).
export class Component_MFH {
  public static intUnit_select: number;
  public static intEquip: number;

  // MFH setup screen: insideDiameter_MFH
  public static sngID: number;
  // MFH setup screen: nominalThickness_MFH
  public static sngtnom: number;
  // MFH setup screen: internalLoss_MFH
  public static sngLOSSi: number;
  // MFH setup screen: externalLoss_MFH
  public static sngLOSSe: number;
  // MFH setup screen: internalFca_MFH
  public static sngFCAi: number;
  // MFH setup screen: externalFca_MFH
  public static sngFCAe: number;
  // MFH setup screen: allowableStress_MFH
  public static sngS_stress: number;
  // MFH setup screen: circumferentialWeldJointEfficiency_MFH
  public static sngE_c: number;
  // MFH setup screen: designLiquidHead_MFH
  public static sngH_L: number;
  // MFH setup screen: specificGravity_MFH
  public static sngs_g: number;
  // MFH setup screen: shellCourseBottomHeight_MFH
  public static sngH_c: number;
  // MFH setup screen: weldAtThicknessTransition_MFH
  // Inspection Data screen: textBox3_DI_sngH_f (H_ml)
  public static sngH_f: number;
  // Inspection Data screen: textBox8_DI (H_w)
  public static sngH_w: number;

  public static sngtrd: number;
  public static sngtc: number;
  public static sngtmin: number;
  public static sngMFH: number;
  public static sngH: number;
  public static sngDi: number;
  public static sngDo: number;
  public static sngMFH_r: number;

  // ── LML/MFH results snapshot (set by inspection-data calc, used by report/export) ──
  public static mfhGmlCalcResult: string = "";
  public static mfhLmlCalcResult: string = "";
  public static snap_tam: number = 0;
  public static snap_tmm: number = 0;
  public static snap_FCAml: number = 0;
  public static snap_sLong: number = 0;
  public static snap_cCirc: number = 0;
  public static snap_lmsd: number = 0;
  public static snap_gr: number = NaN;
  public static sngMFH_hydro: number;

  public static validationMessage = [];
  public static alertMessage = [];

  private static getStructuralMinThickness(unitSelect: number, tankDiameter: number): number {
    if (unitSelect === 0) {
      if (tankDiameter < 50) {
        return 0.1875;
      } else if (tankDiameter <= 120) {
        return 0.25;
      } else if (tankDiameter <= 200) {
        return 0.3125;
      }
      return 0.375;
    }

    if (tankDiameter < 15) {
      return 5;
    } else if (tankDiameter <= 36) {
      return 6;
    } else if (tankDiameter <= 60) {
      return 8;
    }
    return 10;
  }

  // Reset MFH state for a fresh assessment/session.
  public static MFH_initialize(): void {
    this.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    this.intEquip = 8;

    this.sngID = -1;
    this.sngtnom = -1;
    this.sngLOSSi = -1;
    this.sngLOSSe = -1;
    this.sngFCAi = -1;
    this.sngFCAe = -1;
    this.sngS_stress = -1;
    this.sngE_c = -1;
    this.sngH_L = 0;
    this.sngs_g = 0;
    this.sngH_c = -1;
    this.sngH_f = -1;
    this.sngH_w = -1;


    this.sngtrd = -1;
    this.sngtc = -1;
    this.sngtmin = -1;
    this.sngMFH = -1;
    this.sngH = -1;
    this.sngDi = -1;
    this.sngDo = -1;
    this.sngMFH_r = -1;

    this.validationMessage = [];
    this.alertMessage = [];

    this.mfhGmlCalcResult = "";
    this.mfhLmlCalcResult = "";
    this.snap_tam = 0;
    this.snap_tmm = 0;
    this.snap_FCAml = 0;
    this.snap_sLong = 0;
    this.snap_cCirc = 0;
    this.snap_lmsd = 0;
    this.snap_gr = NaN;

    CalcTemplate.sngMFH = -1;
    CalcTemplate.sngMFH_d = -1;
    CalcTemplate.sngMFH_r = -1;
    CalcTemplate.sngH_f = -1;
    CalcTemplate.sngRSF_a = 0.9;
  }

  // Validate currently enabled MFH inputs and collect user-facing messages.
  public static calc_Check(mfhForm: FormGroup): boolean {
    this.validationMessage = [];
    this.alertMessage = [];

    const errors: string[] = [];

    const insideDiameter = mfhForm.get("insideDiameter_MFH") as FormControl;
    const nominalThickness = mfhForm.get("nominalThickness_MFH") as FormControl;
    const internalLoss = mfhForm.get("internalLoss_MFH") as FormControl;
    const externalLoss = mfhForm.get("externalLoss_MFH") as FormControl;
    const internalFca = mfhForm.get("internalFca_MFH") as FormControl;
    const externalFca = mfhForm.get("externalFca_MFH") as FormControl;
    const allowableStress = mfhForm.get("allowableStress_MFH") as FormControl;
    const circumferentialWeldJointEfficiency = mfhForm.get("circumferentialWeldJointEfficiency_MFH") as FormControl;
    const designLiquidHead = mfhForm.get("designLiquidHead_MFH") as FormControl;
    const specificGravity = mfhForm.get("specificGravity_MFH") as FormControl;
    const allowableRemainingStrengthFactor = mfhForm.get("allowableRemainingStrengthFactor_MFH") as FormControl;
    const shellCourseBottomHeight = mfhForm.get("shellCourseBottomHeight_MFH") as FormControl;

    // Reusable numeric validator for all MFH controls.
    const validatePositive = (control: FormControl, label: string, allowZero: boolean = false) => {
      if (!control || !control.enabled) {
        return;
      }
      if (!Utility.isTextADouble(control.value)) {
        errors.push(`${label} - invalid value.`);
        return;
      }
      const value = Number(control.value);
      if (allowZero ? value < 0 : value <= 0) {
        errors.push(`${label} - cannot be less than ${allowZero ? "zero" : "or equal to zero"}.`);
      }
    };

    validatePositive(insideDiameter, "Original inside diameter, D");
    validatePositive(nominalThickness, "Original nominal thickness, tnom");
    validatePositive(internalLoss, "Current uniform metal loss (internal), LOSSi", true);
    validatePositive(externalLoss, "Current uniform metal loss (external), LOSSe", true);
    validatePositive(internalFca, "Future corrosion allowance (internal), FCAi", true);
    validatePositive(externalFca, "Future corrosion allowance (external), FCAe", true);
    validatePositive(allowableStress, "Allowable stress according to API 653, S");
    validatePositive(circumferentialWeldJointEfficiency, "Weld joint efficiency, E");
    validatePositive(designLiquidHead, "Design liquid head, H_L", true);
    validatePositive(specificGravity, "Specific gravity, s_g");
    validatePositive(allowableRemainingStrengthFactor, "Allowable remaining strength factor, RSFa", true);
    validatePositive(shellCourseBottomHeight, "Vertical distance from tank floor to lower edge of shell course under assessment, Hc", true);

    if (Utility.isTextADouble(circumferentialWeldJointEfficiency?.value)) {
      const e = Number(circumferentialWeldJointEfficiency.value);
      if (e < 0.7 || e > 1) {
        errors.push("Weld joint efficiency, E - must be between 0.7 and 1.");
      }
    }

    if (
      Utility.isTextADouble(nominalThickness?.value) &&
      Utility.isTextADouble(internalLoss?.value) &&
      Utility.isTextADouble(externalLoss?.value) &&
      Utility.isTextADouble(internalFca?.value) &&
      Utility.isTextADouble(externalFca?.value)
    ) {
      const tnom = Number(nominalThickness.value);
      const lossTotal = Number(internalLoss.value) + Number(externalLoss.value);
      const fcaTotal = Number(internalFca.value) + Number(externalFca.value);

      if (lossTotal >= tnom) {
        errors.push("LOSSi + LOSSe cannot be greater than or equal to tnom.");
      }

      if (fcaTotal >= tnom) {
        errors.push("FCAi + FCAe cannot be greater than or equal to tnom.");
      }

      if (lossTotal + fcaTotal >= tnom) {
        errors.push("LOSSi + LOSSe + FCAi + FCAe cannot be greater than or equal to tnom.");
      }
    }

    if (
      Utility.isTextADouble(designLiquidHead?.value) &&
      Utility.isTextADouble(shellCourseBottomHeight?.value)
    ) {
      const hL = Number(designLiquidHead.value);
      const hC = Number(shellCourseBottomHeight.value);
      if (hC >= hL) {
        errors.push("Hc cannot be greater than or equal to H_L.");
      }
    }

    this.validationMessage = errors;
    return errors.length === 0;
  }

  // Compute MFH summary values and return display-ready summary HTML.
  public static MFH_calc(): string {

    console.log("[MFH] ── Raw inputs ──────────────────────────────────");
    console.log("[MFH]   ID=%o  tnom=%o  LOSSi=%o  LOSSe=%o  FCAi=%o  FCAe=%o",
      this.sngID, this.sngtnom, this.sngLOSSi, this.sngLOSSe, this.sngFCAi, this.sngFCAe);
    console.log("[MFH]   H_L=%o  H_c=%o  s_g=%o  S=%o  E_c=%o  H_w=%o",
      this.sngH_L, this.sngH_c, this.sngs_g, this.sngS_stress, this.sngE_c, this.sngH_w);

    // Hydrostatic head at the course under evaluation.
    this.sngH = this.sngH_L - this.sngH_c;
    console.log("[MFH] H  = H_L - H_c  =>  %o - %o  = %o", this.sngH_L, this.sngH_c, this.sngH);

    // Diameter terms used by the MFH equations after accounting for internal/external loss and FCA.
    // US: ID in ft and losses/FCA in in -> divide by 12.
    // SI: ID in m and losses/FCA in mm -> divide by 1000.
    const diameterAdjustmentDivisor = this.intUnit_select === 0 ? 12 : 1000;
    this.sngDi = this.sngID + 2 * (this.sngLOSSi / diameterAdjustmentDivisor) + 2 * (this.sngFCAi / diameterAdjustmentDivisor);
    console.log("[MFH] Di = ID + 2*(LOSSi/%o) + 2*(FCAi/%o)  =>  %o + 2*%o + 2*%o  = %o",
      diameterAdjustmentDivisor, diameterAdjustmentDivisor, this.sngID, (this.sngLOSSi / diameterAdjustmentDivisor), (this.sngFCAi / diameterAdjustmentDivisor), this.sngDi);

    this.sngDo = this.sngID + 2 * (this.sngLOSSe / diameterAdjustmentDivisor) + 2 * (this.sngFCAe / diameterAdjustmentDivisor);
    console.log("[MFH] Do = ID + 2*(LOSSe/%o) + 2*(FCAe/%o)  =>  %o + 2*%o + 2*%o  = %o",
      diameterAdjustmentDivisor, diameterAdjustmentDivisor, this.sngID, (this.sngLOSSe / diameterAdjustmentDivisor), (this.sngFCAe / diameterAdjustmentDivisor), this.sngDo);

    // Remaining measured thickness before future corrosion allowance.
    this.sngtrd = this.sngtnom - this.sngLOSSi - this.sngLOSSe;
    console.log("[MFH] trd = tnom - LOSSi - LOSSe  =>  %o - %o - %o  = %o",
      this.sngtnom, this.sngLOSSi, this.sngLOSSe, this.sngtrd);

    // Corroded design thickness available for MFH evaluation.
    this.sngtc = this.sngtrd - this.sngFCAi - this.sngFCAe;
    const fca = this.sngFCAi + this.sngFCAe;
    console.log("[MFH] FCA = FCAi + FCAe  =>  %o + %o  = %o", this.sngFCAi, this.sngFCAe, fca);
    console.log("[MFH] tc  = trd - FCAi - FCAe  =>  %o - %o - %o  = %o",
      this.sngtrd, this.sngFCAi, this.sngFCAe, this.sngtc);

    // Shared denominator in tmin equation: allowable stress times weld efficiency.
    const tminDenominator = this.sngS_stress * this.sngE_c;
    console.log("[MFH] tminDenominator = S * E_c  =>  %o * %o  = %o",
      this.sngS_stress, this.sngE_c, tminDenominator);

    const hydroCoefficient = this.intUnit_select === 0 ? 2.6 : 4.9;
    // Shared denominator in MFH equation: hydroCoefficient * D * specific gravity.
    const mfhDenominator = hydroCoefficient * this.sngDi * this.sngs_g;
    console.log("[MFH] mfhDenominator  = %o * Di * s_g  =>  %o * %o * %o  = %o",
      hydroCoefficient, hydroCoefficient, this.sngDi, this.sngs_g, mfhDenominator);

    const oneFootInCurrentUnits = this.intUnit_select === 0 ? 1 : 0.3;
    const tminStructural = this.getStructuralMinThickness(this.intUnit_select, this.sngDi);
    console.log("[MFH] D(%o)=%o -> tmin_st=%o",
      this.intUnit_select === 0 ? "ft" : "m", this.sngDi, tminStructural);

    // tmin_hydro for component-information display always uses a fixed 1 ft (0.3048 m) offset.
    const hydroOffset = oneFootInCurrentUnits;
    const tminHydro =
      tminDenominator !== 0
        ? (hydroCoefficient * (this.sngH - hydroOffset) * this.sngDi * this.sngs_g) / tminDenominator
        : -1;
    console.log("[MFH] tmin_hydro = %o*(H_L-H_c-%o)*Di*s_g/(S*E_c) = %o",
      hydroCoefficient, hydroOffset, tminHydro);

    // Minimum required thickness is the maximum of structural and hydrostatic requirements.
    this.sngtmin = Math.max(tminStructural, tminHydro);
    console.log("[MFH] tmin = max(tmin_st, tmin_hydro) = max(%o, %o) = %o", tminStructural, tminHydro, this.sngtmin);

    // MFH_hydro always adds 1 ft (or 0.3048 m) regardless of H_w.
    const mfhHydroBase = mfhDenominator !== 0 ? (this.sngtc * this.sngS_stress) / mfhDenominator : -1;
    const mfhHydro = mfhHydroBase !== -1 ? mfhHydroBase + this.sngH_c + oneFootInCurrentUnits : -1;
    this.sngMFH = mfhHydro !== -1 ? Math.min(mfhHydro, this.sngH_L) : -1;
    console.log("[MFH] MFH_hydro = (tc*S)/(%o*Di*s_g) + H_c + %o = %o", hydroCoefficient, oneFootInCurrentUnits, mfhHydro);
    console.log("[MFH] MFH = min(MFH_hydro, H_L) = min(%o, %o) = %o", mfhHydro, this.sngH_L, this.sngMFH);
    console.log("[MFH] ────────────────────────────────────────────────");
    //assigning MFH Hydro to public static value for use in inspection-data component
    this.sngMFH_hydro = mfhHydro;

    const cappedMFH = Number.isFinite(this.sngMFH) && Number.isFinite(this.sngH_L)
      ? Math.min(this.sngMFH, this.sngH_L)
      : this.sngMFH;
    this.sngMFH = cappedMFH;

    CalcTemplate.sngMFH = this.sngMFH;
    CalcTemplate.sngMFH_d = this.sngH_L;
    CalcTemplate.sngMFH_r = this.sngMFH;
    CalcTemplate.sngH_f = this.sngH_c;
    this.sngMFH_r = this.sngMFH;

    let result = "";
    switch (this.intUnit_select) {
      case 0: // US Customary
        result +=
          "Current measured thickness, trd = tnom - LOSSi - LOSSe = " +
          this.sngtrd.toFixed(3) +
          " inch<br />";
        result +=
          "Future corrosion allowance, FCA = FCAi + FCAe = " +
          fca.toFixed(3) +
          " inch<br />";
        result +=
          "Future corroded thickness, tc = trd - FCA = " +
          this.sngtc.toFixed(3) +
          " inch<br />";
        result +=
          "Inside diameter corrected for LOSSi and FCAi, D = " +
          this.sngDi.toFixed(3) +
          " ft<br />";
        result +=
          "Minimum required thickness, tmin = " +
          this.sngtmin.toFixed(3) +
          " inch<br />";
        result +=
          " Calc. Maximum Filling Height (MFH) = " +
          this.sngMFH.toFixed(3) +
          " ft";
        break;

      case 1: // SI
        result +=
          "Current measured thickness, trd = tnom - LOSSi - LOSSe = " +
          this.sngtrd.toFixed(1) +
          " mm<br />";
        result +=
          "Future corrosion allowance, FCA = FCAi + FCAe = " +
          fca.toFixed(1) +
          " mm<br />";
        result +=
          "Future corroded thickness, tc = trd - FCA = " +
          this.sngtc.toFixed(1) +
          " mm<br />";
        result +=
          "Inside diameter corrected for LOSSi and FCAi, D = " +
          this.sngDi.toFixed(3) +
          " m<br />";
        result +=
          "Minimum required thickness, tmin = " +
          this.sngtmin.toFixed(1) +
          " mm<br />";
        result +=
          "Calc. Maximum Filling Height (MFH) = " +
          this.sngMFH.toFixed(3) +
          " m";
        break;
    }

    return `<font color="blue">` + result + `</font>`;
  }

  // ─────────────────────────────────────────────────────────────────
  //  LML MFH – Export / Import / Report  (all strictly self-contained)
  // ─────────────────────────────────────────────────────────────────

  public static ExportToJson(radioButtonDI: string): string {
    const unitType = this.intUnit_select === 0 ? "US" : "SI";
    const dataToExport: any = {
      _mfhLml: true,
      // Slim damage-class discriminator (1 = LML, 3 = Gouges) kept at the top
      // level instead of embedding a mostly-empty Component_MAWP snapshot.
      strD_iclass: Component_MAWP.strD_iclass,
      strD_class: Component_MAWP.strD_class,
      Component_MFH: { ...Component_MFH },
      CalcTemplate: { ...CalcTemplate },
      typeaData: {
        typeAresult: "PASS",
        TypeARadioSelect: "CylindricalAtmosphericStorageTankShellCourses",
        Input1_text: "", Input1_value: "",
        Input2_text: "", Input2_value: "",
        ComponetType: "Tank",
        TypeofUnit: unitType,
      },
      typedamageval: radioButtonDI,
    };
    return JSON.stringify(dataToExport);
  }

  public static ImportFromJson(jsonDataResult: any): void {
    Component_MFH.MFH_initialize();
    Object.assign(Component_MFH, jsonDataResult.Component_MFH);
    Object.assign(CalcTemplate, jsonDataResult.CalcTemplate);

    // Restore the damage-class discriminator so downstream app state
    // (getActiveDamageClass, inspection-form dispatch) stays consistent.
    const discriminatorIclass =
      jsonDataResult.strD_iclass ?? jsonDataResult.Component_MAWP?.strD_iclass;
    if (discriminatorIclass !== undefined && discriminatorIclass !== null) {
      Component_MAWP.strD_iclass = Number(discriminatorIclass);
    }
    const discriminatorClass =
      jsonDataResult.strD_class ?? jsonDataResult.Component_MAWP?.strD_class;
    if (discriminatorClass) {
      Component_MAWP.strD_class = discriminatorClass;
    }

    // Backward compatibility with older files that embedded the full Component_MAWP.
    if (jsonDataResult.Component_MAWP) {
      Object.assign(Component_MAWP, jsonDataResult.Component_MAWP);
    }
  }

  public static MFH_LML_report(): string {
    const us = Component_MFH.intUnit_select === 0;
    const tU = us ? "inch" : "mm";
    const hU = us ? "ft" : "m";
    const tF = us ? 3 : 1;
    const hF = us ? 3 : 2;
    const fmt = (v: number, d = 3) =>
      Number.isFinite(Number(v)) ? Number(v).toFixed(d) : "—";

    let r = "";
    r += "<br/><br/><center><b>API 579-1/ASME FFS-1 Standard 2021 Edition</b></center>";
    r += "<center><b>Local Metal Loss – Maximum Filling Height Assessment</b></center><br/><br/>";

    r += "<b>Component MFH Information:</b><br/><br/>";
    r += `Inside Diameter, D = ${fmt(Component_MFH.sngID, hF)} ${hU}<br/>`;
    r += `Nominal Thickness, tnom = ${fmt(Component_MFH.sngtnom, tF)} ${tU}<br/>`;
    r += `Corroded Thickness, tc = ${fmt(Component_MFH.sngtc, tF)} ${tU}<br/>`;
    r += `Allowable Stress, S = ${fmt(Component_MFH.sngS_stress)} psi<br/>`;
    r += `Weld Joint Efficiency, E_c = ${fmt(Component_MFH.sngE_c, 2)}<br/>`;
    r += `Design Liquid Head, H_L = ${fmt(Component_MFH.sngH_L, hF)} ${hU}<br/>`;
    r += `Shell Course Bottom Height, H_c = ${fmt(Component_MFH.sngH_c, hF)} ${hU}<br/>`;
    r += `Specific Gravity, s_g = ${fmt(Component_MFH.sngs_g, 2)}<br/>`;
    r += `MFH (from component screen) = ${fmt(Component_MFH.sngMFH, hF)} ${hU}<br/>`;
    r += `Allowable RSF, RSFa = ${fmt(CalcTemplate.sngRSF_a, 2)}<br/><br/>`;

    r += "<b>Inspection Data:</b><br/><br/>";
    r += `Average Measured Thickness, tam = ${fmt(Component_MFH.snap_tam, tF)} ${tU}<br/>`;
    r += `Minimum Measured Thickness, tmm = ${fmt(Component_MFH.snap_tmm, tF)} ${tU}<br/>`;
    r += `FCA inside damage area, FCAml = ${fmt(Component_MFH.snap_FCAml, tF)} ${tU}<br/>`;
    r += `Height to lower flaw edge, H_ml = ${fmt(Component_MFH.sngH_f, hF)} ${hU}<br/>`;
    r += `Axial length of metal loss, s = ${fmt(Component_MFH.snap_sLong, tF)} ${tU}<br/>`;
    r += `Circ. length of metal loss, c = ${fmt(Component_MFH.snap_cCirc, tF)} ${tU}<br/>`;
    r += `Distance to structural discontinuity, Lmsd = ${fmt(Component_MFH.snap_lmsd, tF)} ${tU}<br/>`;
    if (Number.isFinite(Component_MFH.snap_gr)) {
      r += `Groove bottom radius, gr = ${fmt(Component_MFH.snap_gr, tF)} ${tU}<br/>`;
    }
    r += "<br/>";

    r += "<b>Assessment Results:</b><br/><br/>";
    r += Component_MFH.mfhLmlCalcResult || "(No result computed yet)";

    return r;
  }

  public static MFH_GML_report(): string {
    const us = Component_MFH.intUnit_select === 0;
    const tU = us ? "inch" : "mm";
    const hU = us ? "ft" : "m";
    const stressU = us ? "psi" : "MPa";
    const tF = us ? 3 : 1;
    const hF = us ? 3 : 2;
    const fmt = (v: number, d = 3) =>
      Number.isFinite(Number(v)) ? Number(v).toFixed(d) : "—";

    let r = "";
    r += "<br/><br/><center><b>API 579-1/ASME FFS-1 Standard 2021 Edition</b></center>";
    r += "<center><b>General Metal Loss – Maximum Filling Height Assessment</b></center><br/><br/>";

    r += "<b>Component MFH Information:</b><br/><br/>";
    r += `Component type = Tank<br/>`;
    r += `Inside Diameter, D = ${fmt(Component_MFH.sngID, hF)} ${hU}<br/>`;
    r += `Nominal Thickness, tnom = ${fmt(Component_MFH.sngtnom, tF)} ${tU}<br/>`;
    r += `Current measured (uniform) thickness, trd = ${fmt(Component_MFH.sngtrd, tF)} ${tU}<br/>`;
    r += `Future corroded thickness, tc = ${fmt(Component_MFH.sngtc, tF)} ${tU}<br/>`;
    r += `Minimum required thickness, tmin = ${fmt(Component_MFH.sngtmin, tF)} ${tU}<br/>`;
    r += `Allowable Stress, S = ${fmt(Component_MFH.sngS_stress, us ? 0 : 2)} ${stressU}<br/>`;
    r += `Weld Joint Efficiency, E_c = ${fmt(Component_MFH.sngE_c, 2)}<br/>`;
    r += `Design Liquid Head, H_L = ${fmt(Component_MFH.sngH_L, hF)} ${hU}<br/>`;
    r += `Distance from the lower edge of the shell course under assessment to the tank floor, H_c = ${fmt(Component_MFH.sngH_c, hF)} ${hU}<br/>`;
    r += `Specific Gravity, s_g = ${fmt(Component_MFH.sngs_g, 2)}<br/>`;
    r += ` Calc. Maximum Filling Height, MFH = ${fmt(Component_MFH.sngMFH, hF)} ${hU}<br/><br/>`;

    r += "<b>Inspection Data:</b><br/><br/>";
    r += `Average Measured Thickness, tam = ${fmt(Component_MFH.snap_tam, tF)} ${tU}<br/>`;
    r += `Minimum Measured Thickness, tmm = ${fmt(Component_MFH.snap_tmm, tF)} ${tU}<br/>`;
    r += `Future corrosion allowance inside the damage area, FCAml = ${fmt(Component_MFH.snap_FCAml, tF)} ${tU}<br/>`;
    r += `Axial distance from the lower edge of the metal loss area to to the tank floor, H_ml = ${fmt(Component_MFH.sngH_f, hF)} ${hU}<br/><br/>`;

    r += "<b>Assessment Results:</b><br/><br/>";
    r += Component_MFH.mfhGmlCalcResult || "(No result computed yet)";

    return r;
  }
}
